<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`运单列表`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
       :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #edittime="params">
        {{ params.params.edittime ? params.params.edittime.slice(0, 10) : "-" }}
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

let fromPath = null

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "财务管理", path: `/finance/accounts` },
        { name: "合同账款管理", path: `/finance/accounts` },
        { name: "车辆列表", path: `/finance/hirecarlist` },
        { name: "运单列表" },
      ],
      formInline: {
        order_type: 2,
        ischeck: 2,
        isstatus: 4,
      },
      searchDateOptions: [
        { keyName: "predict_loading_date", label: "装货日期", },
        { keyName: "predict_unloading_date", label: "卸货日期", },
      ],
      formCtrl: [
        // {
        //   ...this.ctrls.fleet,
        //   options: [],
        // },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 130 },
        { keyName: "pcustomname", label: "承运公司", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 110 },
        { keyName: "name", label: "货物名称", minwidth: 110 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", minwidth: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', width: 110 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', width: 140 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "运费单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "承运单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "运费金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "承运金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', width: 110 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ys_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "yf_freight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "nickname", label: "派单人", minwidth: 120 },
      ],
      getTotalProperty: [
        'caton',
        'inton',
        'unton',
        "kuiton",
        "kuitotal",
        "freight",
        "additional_fees",
        "compen",
        'ys_freight',
        'yf_freight',
        'infreight',
      ],
      baseParams: [
        'order_type',
        'ischeck',
        'isstatus',
        'license',
        'contractid',
      ],
    };
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    fromPath = from.path
    next()
  },
  mounted() {
    const { contractid } = this.$route.query
    this.breadcrumb[2].path += '?id=' + contractid
    this.getFleet()
    this.setQueryParams();
    this.$nextTick(this.getList);
    if (this.$route.path.includes('contract')) {
      this.breadcrumb = [
        { name: "合同管理", path: `/contract/list` },
        { name: "合同列表", path: `/contract/list` },
        { name: "合同统计", path: fromPath },
        { name: "运单列表" },
      ]
    }
  },
};
</script>

<style lang="less" scoped>
.el-button--success {
  background-color: #13ce66;
  border-color: #13ce66;
}

.main {
  /deep/ .el-form--inline {
    .item {
      margin-right: 10px;
    }
  }
}
</style>
